export const increaseCounter = (tracker, goal, params = {}) => {
  try {
    ym(tracker, 'reachGoal', goal, params);
  } catch (e) {
    console.log('Error', e);
  }
};
